// Static, accessible figures supplied in the approved HTML reference.
export function WetLabPanel() {
  return <div className="r-showcase-computation">
    <header className="r-showcase-laep-heading">
      <h3>LAEP 让 Sciland 与实验仪器双向通信</h3>
      <p lang="en">Laboratory–Agent Exchange Protocol</p>
    </header>
    <div className="r-showcase-research-pair">
      <article className="r-showcase-domain r-experiment">
        <div className="r-showcase-domain-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
            <path d="M221.69,199.77,160,96.92V40h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V96.92L34.31,199.77A16,16,0,0,0,48,224H208a16,16,0,0,0,13.72-24.23ZM110.86,103.25A7.93,7.93,0,0,0,112,99.14V40h32V99.14a7.93,7.93,0,0,0,1.14,4.11L183.36,167c-12,2.37-29.07,1.37-51.75-10.11-15.91-8.05-31.05-12.32-45.22-12.81ZM48,208l28.54-47.58c14.25-1.74,30.31,1.85,47.82,10.72,19,9.61,35,12.88,48,12.88a69.89,69.89,0,0,0,19.55-2.7L208,208Z" />
          </svg>
          <h4>实验控制</h4>
        </div>
        <p className="r-showcase-domain-copy">通过逆向工程让仪器原生支持 LAEP，Sciland 可下发实验参数并控制执行</p>
        <ul className="r-showcase-domain-examples" aria-label="实验仪器类型">
          <li>蛋白纯化系统</li>
          <li>分子互作分析仪（SPR/BLI）</li>
          <li>热稳定性分析仪</li>
          <li>多功能酶标仪</li>
        </ul>
      </article>
      <article className="r-showcase-domain r-compute">
        <div className="r-showcase-domain-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
            <path d="M196.12,128c24.65-34.61,37.22-70.38,19.74-87.86S162.61,35.23,128,59.88C93.39,35.23,57.62,22.66,40.14,40.14S35.23,93.39,59.88,128c-24.65,34.61-37.22,70.38-19.74,87.86h0c5.63,5.63,13.15,8.14,21.91,8.14,18.48,0,42.48-11.17,66-27.88C151.47,212.83,175.47,224,194,224c8.76,0,16.29-2.52,21.91-8.14h0C233.34,198.38,220.77,162.61,196.12,128Zm8.43-76.55c7.64,7.64,2.48,32.4-18.52,63.28a300.33,300.33,0,0,0-21.19-23.57A300.33,300.33,0,0,0,141.27,70C172.15,49,196.91,43.8,204.55,51.45ZM176.29,128a289.14,289.14,0,0,1-22.76,25.53A289.14,289.14,0,0,1,128,176.29a289.14,289.14,0,0,1-25.53-22.76A289.14,289.14,0,0,1,79.71,128,298.62,298.62,0,0,1,128,79.71a289.14,289.14,0,0,1,25.53,22.76A289.14,289.14,0,0,1,176.29,128ZM51.45,51.45c2.2-2.21,5.83-3.35,10.62-3.35C73.89,48.1,92.76,55,114.72,70A304,304,0,0,0,91.16,91.16,300.33,300.33,0,0,0,70,114.73C49,83.85,43.81,59.09,51.45,51.45Zm0,153.1C43.81,196.91,49,172.15,70,141.27a300.33,300.33,0,0,0,21.19,23.57A304.18,304.18,0,0,0,114.73,186C83.85,207,59.09,212.2,51.45,204.55Zm153.1,0c-7.64,7.65-32.4,2.48-63.28-18.52a304.18,304.18,0,0,0,23.57-21.19A300.33,300.33,0,0,0,186,141.27C207,172.15,212.19,196.91,204.55,204.55ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" />
          </svg>
          <h4>数据回传</h4>
        </div>
        <p className="r-showcase-domain-copy">实验记录与原始测量数据通过 LAEP 回到 Sciland，自动整理并用于分析</p>
        <ul className="r-showcase-domain-examples" aria-label="回流数据类型">
          <li>结合曲线</li>
          <li>热稳定性曲线</li>
          <li>细胞报告信号</li>
        </ul>
      </article>
    </div>
    <div className="r-binder-example" aria-labelledby="binder-example-title">
      <div className="r-binder-example-heading">
        <div>
          <p className="r-binder-example-context">cGAS–STING 先天免疫通路</p>
          <h4 id="binder-example-title">STING 蛋白结合剂的多轮优化</h4>
        </div>
      </div>
      <p className="r-binder-example-goal">以阻断通路异常激活为目标，设计蛋白质结合剂（Binder）</p>
      <p className="r-binder-example-method">结合结构预测、候选生成与计算筛选，合成并检测候选蛋白，再用实测反馈优化下一轮设计</p>
      <div className="r-binder-trends">
        <figure className="r-binder-trend r-affinity">
          <figcaption>
            <h5>
              结合亲和力 K
              <sub>D</sub>
            </h5>
            <span>越低，结合越强</span>
          </figcaption>
          <picture>
            <source media="(max-width: 760px)" srcSet="/design-refresh/binder-affinity-mobile.svg" />
            <img width="420" height="225" alt="结合亲和力：第1轮 180 nM，第2轮 72 nM，第3轮 85 nM，第4轮 18 nM" src="/design-refresh/binder-affinity.svg" />
          </picture>
          <div className="r-binder-trend-result">
            <span>SPR / BLI 测量</span>
            <strong>
              180
               → 
              18
              <small>nM</small>
            </strong>
          </div>
        </figure>
        <figure className="r-binder-trend r-stability">
          <figcaption>
            <h5>
              热稳定性 T
              <sub>m</sub>
            </h5>
            <span>越高，耐热性越好</span>
          </figcaption>
          <picture>
            <source media="(max-width: 760px)" srcSet="/design-refresh/binder-stability-mobile.svg" />
            <img width="420" height="225" alt="Binder 自身热稳定性：第1轮 49摄氏度，第2轮 54摄氏度，第3轮 62摄氏度，第4轮 66摄氏度" src="/design-refresh/binder-stability.svg" />
          </picture>
          <div className="r-binder-trend-result">
            <span>Binder 自身的热稳定性</span>
            <strong>
              49
               → 
              66
              <small>°C</small>
            </strong>
          </div>
        </figure>
      </div>
    </div>
  </div>;
}
export function EvolutionPanel() {
  return <div className="r-rsi-evolution">
    <header className="r-rsi-intro">
      <h3>
        <span>RSI</span>
        递归自我改进
      </h3>
      <p>让 Sciland 从研究经验与失误中学习，持续改进工具选择、研究方法和工作流。</p>
      <p>经过验证的改进会保留下来，用于后续研究，也用于改进学习与评估的方法。</p>
    </header>
    <figure className="r-rsi-benchmark">
      <figcaption>
        <h4>BiomniBench-DA</h4>
        <div className="r-rsi-score-change" aria-label="基线 81.6 分，自进化阶段3 88.0 分">
          <span>81.6</span>
          <span aria-hidden="true">→</span>
          <strong>
            88.0
            <small>分</small>
          </strong>
        </div>
      </figcaption>
      <picture>
        <source media="(max-width: 760px)" srcSet="/design-refresh/rsi-benchmark-mobile.svg" />
        <img width="930" height="380" alt="BiomniBench-DA，三道开发题 · 已交付结果平均评分：基线 81.6 分，探索性 95% 区间 76.3 至 86.9；提示词自进化 87.0 分，因样本不足未绘制区间；自进化阶段1 87.0 分，探索性 95% 区间 83.0 至 90.8；自进化阶段2 88.1 分，探索性 95% 区间 85.9 至 90.3；自进化阶段3 88.0 分，探索性 95% 区间 86.0 至 89.9" src="/design-refresh/rsi-benchmark.svg" />
      </picture>
      <p className="r-rsi-benchmark-note">
        <span>95% 区间</span>
        <span>多轮进化后，得分趋于稳定</span>
      </p>
    </figure>
  </div>;
}
